import React, { FunctionComponent } from 'react';

import { Modal } from 'react-bootstrap';

import { ModalStructureProps } from 'directory/listings/notification-modals/types';

import 'directory/listings/notification-modals/components/ModalStructure.scss';

export const ModalStructure: FunctionComponent<ModalStructureProps> = ({
    show,
    onHide,
    title,
    size = 'xl',
    children,
    footer,
    closeButton = true,
    closeOnBackdropClick = false,
    closeOnEscape = false,
    dialogClassName,
    contentClassName,
    bodyClassName,
}) => {
    const shouldShowHeader = !!title || closeButton;
    const shouldShowFooter = !!footer;

    const getBodyClassName = (): string => {
        const classes = ['modal-structure__body'];

        if (bodyClassName) {
            classes.push(bodyClassName);
        }

        return classes.join(' ');
    };

    const renderHeader = () => {
        if (!shouldShowHeader) {
            return null;
        }

        if (title && closeButton) {
            return (
                <Modal.Header closeButton className="modal-structure__header">
                    <Modal.Title className="modal-structure__title">{title}</Modal.Title>
                </Modal.Header>
            );
        }

        if (title && !closeButton) {
            return (
                <Modal.Header closeButton={false} className="modal-structure__header">
                    <Modal.Title className="modal-structure__title">{title}</Modal.Title>
                </Modal.Header>
            );
        }

        if (!title && closeButton) {
            return <Modal.Header closeButton className="modal-structure__header" />;
        }

        return null;
    };

    return (
        <Modal
            size={size}
            show={show}
            onHide={onHide}
            centered
            backdrop={closeOnBackdropClick ? true : 'static'}
            keyboard={closeOnEscape}
            dialogClassName={dialogClassName}
            contentClassName={contentClassName}
        >
            {renderHeader()}

            <Modal.Body className={getBodyClassName()}>{children}</Modal.Body>

            {shouldShowFooter && <Modal.Footer className="modal-structure__footer">{footer}</Modal.Footer>}
        </Modal>
    );
};
